import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('tfg_cookie_consent');
    if (!consent) setShow(true);
  }, []);

  const accept = () => { localStorage.setItem('tfg_cookie_consent', 'accepted'); setShow(false); };
  const decline = () => { localStorage.setItem('tfg_cookie_consent', 'declined'); setShow(false); };

  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1C1917] text-[#FAFAFA] px-4 sm:px-8 py-4" role="dialog" aria-label="Cookie consent" data-testid="cookie-consent">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm">We use cookies to enhance your experience, analyze traffic, and serve relevant ads. By clicking "Accept", you consent to our use of cookies. <Link to="/privacy" className="text-[#C5A028] hover:underline">Privacy Policy</Link></p>
        <div className="flex gap-3 flex-shrink-0">
          <button onClick={decline} className="px-5 py-2 border border-[#78716C] text-sm font-medium hover:border-[#FAFAFA] transition-colors" data-testid="cookie-decline">Decline</button>
          <button onClick={accept} className="px-5 py-2 bg-[#C5A028] text-[#1C1917] text-sm font-bold hover:bg-[#E2BE45] transition-colors" data-testid="cookie-accept">Accept</button>
        </div>
      </div>
    </div>
  );
}
